import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product",
  "use": "icon-product-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-product\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 7.00003H7V4.00003H4V7.00003ZM8.49994 16H11.4999V13H8.49994V16ZM4 16H7V13H4V16ZM4 11.5H7V8.50001H4V11.5ZM8.49994 11.5H11.4999V8.50001H8.49994V11.5ZM12.9999 4.00001V7.00001H15.9999V4.00001H12.9999ZM8.49994 7.00001H11.4999V4.00001H8.49994V7.00001ZM12.9999 11.5H15.9999V8.50001H12.9999V11.5ZM12.9999 16H15.9999V13H12.9999V16Z\" fill=\"#93969B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol